import React from "react";

import { Outlet } from "react-router-dom";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AppstoreOutlined,
  DatabaseOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import useRoleCheck from "utilities/hooks/roleCheck";
import ForbiddenScreen from "pages/403";

const { Content } = Layout;

const getBasePath = (pathname) => {
  const pathSegments = pathname.split("/");
  if (pathSegments[2] === undefined) {
    return "/";
  } else {
    return `/${pathSegments[2]}`;
  }
};

function EquipmentLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useRoleCheck();

  const selectedKey = getBasePath(location.pathname);

  const menuItems = [
    {
      key: "/",
      icon: <AppstoreOutlined />,
      label: "Catalogue",
      onClick: () => navigate("/equipment"),
    },
    {
      key: "/inventory",
      icon: <DatabaseOutlined />,
      label: "Inventory",
      onClick: () => navigate("/equipment/inventory"),
    },
    {
      key: "/calibrations",
      icon: <DatabaseOutlined />,
      label: "Calibrations",
      onClick: () => navigate("/equipment/calibrations"),
    },
    {
      key: "/requests",
      icon: <SolutionOutlined />,
      label: "Requests",
      onClick: () => navigate("/equipment/requests"),
    },
    // {
    //   key: "/training",
    //   icon: <FileDoneOutlined />,
    //   label: "Training",
    //   onClick: () => navigate("/equipment/training"),
    // },
  ];

  if (
    !hasPermission([
      "Operations",
      "IT",
      "Marketing",
      "Sales.RM",
      "Sales.Exec",
      "Audiology",
    ])
  ) {
    return <ForbiddenScreen />;
  }

  return (
    <>
      <Layout className="h-full flex-grow flex flex-col">
        <Menu
          centered
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={menuItems}
        />
        <Content className="h-content flex-grow overflow-y-auto p-4">
          <Outlet />
        </Content>
      </Layout>
    </>
  );
}

export default EquipmentLayout;
